export default __webpack_public_path__ + "static/media/open-sign.e3369a43.png";